import LoginForm from './loginForm.container';

export default LoginForm;